import type { CSSProperties, JSX } from 'react';
import { initialesDuNom } from './initiales.js';
import styles from './Monogramme.module.css';

export type TailleMonogramme = 28 | 32 | 36 | 40 | 48 | 72 | 88;

export interface MonogrammeProps {
  nom: string | null | undefined;
  /** URL d'aperçu du portrait (artiste) ; sans elle, les initiales. */
  portraitUrl?: string | null;
  taille?: TailleMonogramme;
  /** `carre` : signature d'artiste en DM Serif Display ; `rond` : pastille de personne. */
  forme?: 'rond' | 'carre';
  className?: string;
}

/** Pastille d'identité, décorative : le nom est toujours écrit à côté. */
export function Monogramme({
  nom,
  portraitUrl = null,
  taille = 36,
  forme = 'rond',
  className,
}: MonogrammeProps): JSX.Element {
  const lettres = initialesDuNom(nom);
  const style = { '--taille-monogramme': `${String(taille)}px` } as CSSProperties;
  return (
    <span
      className={[styles.monogramme, className].filter(Boolean).join(' ')}
      data-forme={forme}
      data-vide={!portraitUrl && !lettres ? 'true' : undefined}
      style={style}
      aria-hidden="true"
    >
      {portraitUrl ? <img className={styles.portrait} src={portraitUrl} alt="" /> : lettres}
    </span>
  );
}
